export default __webpack_public_path__ + "static/media/pc_step_1_En.59fac952.jpg";